// import 'vuetify/styles'
import './settings.scss'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { en } from 'vuetify/locale'

const albatrossDefaultLightTheme = {
    dark: false,
    colors: {
        primary:'#1F3C73',
        'primary-lighten-1': '#2c5893',
        'primary-lighten-2': '#3368a5',
        'primary-lighten-3': '#3c79b6',
        'primary-lighten-4': '#4486c3',
        'primary-lighten-5': '#5796cb',
        'primary-lighten-6': '#6fa7d3',
        'primary-lighten-7': '#94c0e0',
        'primary-lighten-8': '#bbd8ec',
        'primary-lighten-9': '#e3eff7',
        secondary: '#F6F7F8',
        accent: '#3c79b6',
        error:'#B4221F',
        'error-lighten-1': '#D03331',
        'error-lighten-2': '#EC5552',
        'error-lighten-3': '#ED9B9B',
        'error-lighten-4': '#FECDD2',
        warning: '#FB8C00',
        success:'#1B5E20',
        'success-lighten-1': '#388E3B',
        'success-lighten-2': '#66BB6A',
        'success-lighten-3': '#A5D6A7',
        'success-lighten-4': '#E8F5E9',
        active: '#e3eff7',
        anchor: '#2c5893',
        grey:'#9E9E9E',
        'grey-lighten-1': '#BDBDBD',
        'grey-lighten-2': '#E0E0E0',
        'grey-lighten-3': '#EEEEEE',
        'grey-lighten-4': '#F5F5F5',
        'grey-lighten-5': '#FAFAFA',
        'grey-darken-1': '#757575',
        'grey-darken-2': '#616161',
        'grey-darken-3': '#424242',
        'grey-darken-4': '#212121',
    }
}

export default createVuetify({
//     options: {
//       customProperties: true,
//       variations: true,
//       // defaultTheme: 'light',
//       // variations: {
//       //   colors: ['primary'],
//       //   lighten: 8,
//       //   darken: 4,
//       // },
//     },
//       themes: {
//           // light:
  theme: {
    defaultTheme: 'albatrossDefaultLightTheme',
      themes: {
          albatrossDefaultLightTheme
    }
  },
  display: {
    mobileBreakpoint: 960
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  locale: {
    locale: 'en',
    messages: {
      en: {
        ...en,
        dataFooter: {
          itemsPerPageText: 'Rows per page:',
          pageText: '{0}-{1} of {2}',
          itemsPerPageAll: 'All',
          firstPage: 'First page',
          lastPage: 'Last page',
          nextPage: 'Next page',
          prevPage: 'Previous page'
        }
      }
    }
  }
})
